angular
    .module('tradersyard')
    .directive('messageNode', [
        '$parse',
        '$flex',
        function ($parse, $flex) {
            return {
                scope: false,
                link: function ($scope, $element, $attr) {
                    $scope.mode = 'read';
                },
            };
        },
    ])
    .controller('message-read-ctrl', [
        '$rootScope',
        '$scope',
        'graph-message-factory',
        '$flex',
        function ($rootScope, $scope, $factory, $flex) {
            angular.extend($scope, $flex.data);
        },
    ]);
